<ng-container
  *ngIf="pagesLoaded || bookNotAvailableInLanguage || bookNotAvailable"
>
  <div class="outerbox">
    <header id="toolHeader">
      <div class="header tc relative">
        <app-sharing-modal [book]="selectedBookName"></app-sharing-modal>
        <a
          [attr.href]="embedded ? 'https://knowgod.com' : '/'"
          [attr.target]="embedded ? '_blank' : null"
          class="logo"
        >
          <img src="assets/img/kg-logo-blue.png"
        /></a>
        <div class="page-navigation">
          <a
            [ngClass]="{ 'active-tool': router.url.includes('/tool/') }"
            [routerLink]="['/', _pageParams.langId, 'tools']"
          >
            {{ 'Tools' | i18nextEager }}
          </a>
          <a
            [ngClass]="{ 'active-tool': router.url.includes('/lesson/') }"
            [routerLink]="['/', _pageParams.langId, 'lessons']"
          >
            {{ 'Lessons' | i18nextEager }}
          </a>
        </div>
        <span
          class="kg-gray-dark ng-binding language-selector-toggle"
          (click)="onToggleLanguageSelect()"
        >
          <img src="assets/img/lang.png" class="langicon" /> {{ selectedLang }}
          <i class="fas fa-chevron-up flip"></i>
        </span>
      </div>
      <div id="languageList" class="py25 ng-hide" *ngIf="languagesVisible">
        <div class="mw568">
          <div class="language-search">
            <input
              #languageSearchInput
              type="search"
              dir="auto"
              [(ngModel)]="languageSearchText"
              [placeholder]="'Search languages' | i18nextEager"
              [attr.aria-label]="'Search languages' | i18nextEager"
            />
          </div>
          <div class="language-list" [style.height.px]="languageListHeightPx">
            <ul>
              <li
                class="ng-binding"
                dir="ltr"
                (click)="selectLanguage(lang, true)"
                *ngFor="let lang of filteredLanguages"
              >
                {{ lang.attributes.name }}
              </li>
            </ul>
            <div class="no-language-results" role="status" aria-live="polite">
              <span
                *ngIf="
                  availableLanguages.length > 0 &&
                  filteredLanguages.length === 0
                "
              >
                {{ 'No languages found' | i18nextEager }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </header>

    <div *ngIf="activePage && !bookNotAvailableInLanguage && !bookNotAvailable">
      <app-cyoa-page
        *ngIf="resourceType === 'cyoa' && getPageType() === 'content'"
        [page]="activePage"
        [order]="activePageOrder"
        [totalPages]="totalPages"
      >
      </app-cyoa-page>

      <app-cyoa-card-collection-page
        *ngIf="resourceType === 'cyoa' && getPageType() === 'card-collection'"
        [page]="activePage"
        [order]="activePageOrder"
        [totalPages]="totalPages"
        [setCardUrl]="setCardUrl"
      >
      </app-cyoa-card-collection-page>

      <app-tract-page
        *ngIf="resourceType === 'tract'"
        [page]="activePage"
        [order]="activePageOrder"
        [totalPages]="totalPages"
      >
      </app-tract-page>

      <app-lesson-page
        *ngIf="resourceType === 'lesson'"
        [page]="activePage"
        [order]="activePageOrder"
        [totalPages]="totalPages"
      >
      </app-lesson-page>
    </div>

    <ng-container *ngIf="bookNotAvailableInLanguage">
      <div class="bs-jumbotron tc" style="margin-top: 24px">
        <h2>This book isn't available in the currently selected language.</h2>
      </div>
    </ng-container>

    <ng-container *ngIf="bookNotAvailable">
      <div class="bs-jumbotron tc" style="margin-top: 24px">
        <h2>Failed to load the book.</h2>
      </div>
    </ng-container>
  </div>
</ng-container>
